var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Mutation, State } from 'vuex-simple';
var PartialSaveModule = /** @class */ (function () {
    function PartialSaveModule(root) {
        this.root = root;
        this.restoring = false;
        this.module = '';
        this.description = '';
        this.data = {};
        this.dialogVisible = false;
    }
    PartialSaveModule.prototype.openDialog = function (payload) {
        this.module = payload.module;
        this.data = payload.data;
        this.dialogVisible = true;
    };
    PartialSaveModule.prototype.closeDialog = function () {
        this.module = '';
        this.description = '';
        this.data = {};
        this.dialogVisible = false;
    };
    PartialSaveModule.prototype.setPartialSaveToBeRestored = function (payload) {
        this.data = payload.data;
        this.restoring = true;
    };
    PartialSaveModule.prototype.clearPartialSaveAfterRestore = function () {
        this.module = '';
        this.description = '';
        this.data = {};
        this.dialogVisible = false;
        this.restoring = false;
    };
    __decorate([
        State(),
        __metadata("design:type", Boolean)
    ], PartialSaveModule.prototype, "restoring", void 0);
    __decorate([
        State(),
        __metadata("design:type", String)
    ], PartialSaveModule.prototype, "module", void 0);
    __decorate([
        State(),
        __metadata("design:type", String)
    ], PartialSaveModule.prototype, "description", void 0);
    __decorate([
        State(),
        __metadata("design:type", Object)
    ], PartialSaveModule.prototype, "data", void 0);
    __decorate([
        State(),
        __metadata("design:type", Boolean)
    ], PartialSaveModule.prototype, "dialogVisible", void 0);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PartialSaveModule.prototype, "openDialog", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PartialSaveModule.prototype, "closeDialog", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PartialSaveModule.prototype, "setPartialSaveToBeRestored", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PartialSaveModule.prototype, "clearPartialSaveAfterRestore", null);
    return PartialSaveModule;
}());
export { PartialSaveModule };
